import {
  ListItemButton,
  ListItemIcon,
  ListItemText,
  useMediaQuery,
} from "@mui/material";
import { useDispatch } from "react-redux";

import LogoutIcon from "@mui/icons-material/Logout";
import { Confirm } from "../../utils/alerts";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const LogoutNav = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const isMobile = useMediaQuery("(max-width:900px)");
  const navigate = useNavigate();
  const handleLogout = async () => {
    const { value } = await Confirm(
      t("Sidebar.exit"),
      t("Sidebar.exittext"),
      t("alert.confirmButton"),
      t("newFile.editDialogCancel")
    );
    if (value) {
      navigate("/admin/logOut");
    }
  };

  return (
    <Link
      to={""}
      onClick={handleLogout}
      className={`flex transition-all duration-300 hover:!bg-[#613377] 
          mx-2 rounded-3xl `}
    >
      <ListItemButton>
        <ListItemIcon sx={{ minWidth: "50px" }}>
          <LogoutIcon sx={{ color: "#ffff" }} />
        </ListItemIcon>
        <ListItemText
          disableTypography
          primary={t("Sidebar.exit")}
          sx={{ fontSize: "1rem" }}
        />
      </ListItemButton>
    </Link>
  );
};

export default LogoutNav;
